const percentageChart = [
  "InspectionCompletionRate",
  "EquipmentStatusDistribution",
  "OrganizationInspectionCompletionRate",
];
const labelLocalization = (_labelKey, localization) => {
  const labelValue = {
    InspectinCount: localization.legendnspectinCount,
    TotalCount: localization.legendTotalCount,
    IOCount: localization.legendIOCount,
    NIOCount: localization.legendNIOCount,
    InspectionCompletionRate: localization.legendInspectionCompletionRate,
    IO: localization.legendIO,
    NIO: localization.legendNIO,
    ScrappedCount: localization.legendScrappedCount,
    AverageNIOCount: localization.legendAverageNIOCount,
    TicketsCount: localization.legendTicketsCount,
  };
  return labelValue[_labelKey];
};

export const KpiStatusChart = (chartRes, localization, kpiName) => {
  const Headers = {
    EquipmentStatusDistribution: localization.equipStatusDistHed,
    EquipmentStatusDistributionSubHed: localization.equipStatusDistSubHed,
    PlantEquipmentData: localization.equipmentDataHed,
    PlantEquipmentDataSubHed: localization.PlantEquipmentDataSubHed,
    EquipmentScrappedData: localization.equipScrappedDataHed,
    EquipmentScrappedDataSubHed: localization.equipScrappedDataSubHed,
    EquipmentFrequencyFailures: localization.equipFrequencyFailuresHed,
    EquipmentFrequencyFailuresSubHed: localization.equipFrequencyFailuresSubHed,
    EquipmentGroupTotalInspectionData: localization.equipGrpTotalInspDataHed,
    EquipmentGroupTotalInspectionDataSubHed:
      localization.equipGrpTotalInspDataSubHed,
    InspectorPerfomanceData: localization.InspPerfomanceDataHed,
    InspectorPerfomanceDataSubHed: localization.InspPerfomanceDataSubHed,
    InspectionCompletionRate: localization.InspCompletionRateHed,
    InspectionCompletionRateSubHed: localization.InspCompletionRateSubHed,
    NumberOfTicketsPerEquipmentGroup: localization.numberOfTicketsHed,
    NumberOfTicketsPerEquipmentGroupSubHed: localization.numberOfTicketsSubHed,
    NumberOfTicketsPerEquipment: localization.numberOfTicketsPerEquipment,
    NumberOfTicketsPerEquipmentSubHed:
      localization.numberOfTicketsPerEquipmentSubHed,
    OrganizationInspectorPerfomanceData: localization.inspectorPerformanceHed,
    OrganizationInspectorPerfomanceDataSubHed:
      localization.inspectorPerformanceSubHed,
    OrganizationEquipmentData: localization.equipmentDataHed,
    OrganizationEquipmentDataSubHed: localization.equipmentDataSubHed,
    OrganizationInspectionCompletionRate:
      localization.inspectionCompletionRateHed,
    OrganizationInspectionCompletionRateSubHed:
      localization.inspectionCompletionRateSubHed,
  };
  let _tempItem = {};
  _tempItem = {
    heading: Headers[chartRes.chartId],
    subheading: Headers[chartRes.chartId + "SubHed"],
    chartId: chartRes.chartId,
    chartData: {
      labels: chartRes["chartData"]["labels"],
      isPercentage: percentageChart.includes(chartRes.chartId) ? true : false,
      datasets: [
        ...chartRes.chartData.datasets.map((dataset, index) =>
          createDataSet(
            dataset,
            chartRes.chartId,
            index,
            chartRes.chartData.datasets.length,
            kpiName,
            localization
          )
        ),
      ],
      tickSetting: {
        angle: 45,
        textAnchor: "start",
      },
      chartBottomMargin: calculateChartBottomMargin(
        chartRes["chartData"]["labels"]
      ),
    },
  };
  return { [chartRes.chartId]: _tempItem };
};

function getTextWidth(text, font = "12px Arial") {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context.font = font;
  return context.measureText(text).width;
}

function calculateChartBottomMargin(labels) {
  if (!labels || labels.length === 0) return 0;

  const font = "12px Arial"; // match your tickLabelStyle font size

  // 1. Find widest label in pixels
  const maxWidth = Math.max(
    ...labels.map((label) => getTextWidth(label, font))
  );

  // 2. Calculate rotated height for 45°
  const rotatedHeight = maxWidth * Math.sin(Math.PI / 4); // 45 degrees

  // 3. Add padding
  return rotatedHeight + 40;
}

function createDataSet(
  dataset,
  _chartNameKey,
  index,
  totaldataset,
  kpiValue,
  localization
) {
  const _tempItem = {
    label:
      totaldataset > 0 ? labelLocalization(dataset.label, localization) : "",
    data: dataset.data,
    color:
      kpiValue === "equipmentStatus"
        ? colorSchemeForEquipmentKpi(_chartNameKey, index)
        : colorSchemeForInspectionKpi(_chartNameKey, index),
    type: "bar",
    excelData:
      kpiValue === "equipmentStatus"
        ? ExcelInfoForEquipmentKpi(_chartNameKey, index, localization)
        : ExcelInfoForInspectionKpi(_chartNameKey, index, localization),
  };

  return _tempItem;
}
function colorSchemeForEquipmentKpi(_chartNameKey, index) {
  switch (_chartNameKey) {
    case "EquipmentScrappedData":
      return "#0078BB";
    case "EquipmentStatusDistribution":
      if (index === 0) {
        return "#0078BB";
      } else if (index === 1) {
        return "#1D232E";
      }
    default:
      return "#0078BB";
  }
}
function colorSchemeForInspectionKpi(_chartNameKey, index) {
  switch (_chartNameKey) {
    case "EquipmentGroupTotalInspectionData":
      return "#0078BB";
    case "InspectorPerfomanceData":
      if (index === 0) {
        return "#5D6470";
      } else if (index === 2) {
        return "#E47474";
      } else if (index === 1) {
        return "#51BC51";
      }
    default:
      return "#0078BB";
  }
}

function ExcelInfoForEquipmentKpi(_chartNameKey, index, localization) {
  switch (_chartNameKey) {
    case "EquipmentScrappedData":
      return {
        columnName: localization.equipmentGroup,
      };
    case "EquipmentStatusDistribution":
      return {
        columnName: localization.equipmentGroup,
      };
    default:
      return {
        columnName: localization.equipmentGroup,
      };
  }
}
function ExcelInfoForInspectionKpi(_chartNameKey, index, localization) {
  switch (_chartNameKey) {
    case "EquipmentGroupTotalInspectionData":
      return {
        columnName: localization.equipmentGroup,
      };
    case "InspectorPerfomanceData":
      return {
        columnName: localization.inspectorName,
      };
    case "InspectionCompletionRate":
      return {
        columnName: localization.equipmentGroup,
      };
    case "EquipmentFrequencyFailures":
      return {
        columnName: localization.equipmentGroup,
      };
    default:
      return {
        columnName: localization.equipmentGroup,
      };
  }
}
// export const InspectionKpiChart = (chartRes, localization) => {
//   const Headers = {
//     EquipmentGroupTotalInspectionData: localization.equipGrpTotalInspDataHed,
//     EquipmentGroupTotalInspectionDataSubHed:
//       localization.equipGrpTotalInspDataSubHed,
//     InspectorPerfomanceData: localization.InspPerfomanceDataHed,
//     InspectorPerfomanceDataSubHed: localization.InspPerfomanceDataSubHed,
//     InspectionCompletionRate: localization.InspCompletionRateHed,
//     InspectionCompletionRateSubHed: localization.InspCompletionRateSubHed,
//   };

//   const ExcelTableColumnName = {};
//   let _tempItem = {};
//   _tempItem = {
//     heading: Headers[chartRes.chartId],
//     subheading: Headers[chartRes.chartId + "SubHed"],
//     chartData: {
//       labels: chartRes["chartData"]["labels"],
//       datasets: [
//         ...chartRes.chartData.datasets.map((dataset, index) =>
//           createDataSet(
//             dataset,
//             chartRes.chartId,
//             index,
//             chartRes.chartData.datasets.length,
//             "",
//             localization
//           )
//         ),
//       ],
//       isPercentage: percentageChart.includes(chartRes.chartId) ? true : false,
//       tickSetting:
//         chartRes["chartData"]["labels"].length > 8
//           ? {
//               angle: 45,
//               textAnchor: "start",
//             }
//           : {},
//     },
//   };
//   return { [chartRes.chartId]: _tempItem };
// };

export function apiPayloadCreation(_value, plantId) {
  const NumberDays = parseInt(_value);
  const currentDate = new Date();
  const pastDate = new Date(currentDate);
  pastDate.setDate(pastDate.getDate() - NumberDays);
  const payLoad = {
    PlantId: plantId ? plantId : sessionStorage.getItem("werkId"),
    FromDate: {
      year: pastDate.getFullYear().toString(),
      month: (pastDate.getMonth() + 1).toString(),
      day: pastDate.getDate().toString(),
    },
    ToDate: {
      year: currentDate.getFullYear().toString(),
      month: (currentDate.getMonth() + 1).toString(),
      day: currentDate.getDate().toString(),
    },
  };
  return payLoad;
}
